export default __webpack_public_path__ + "static/media/i (24).5c7eac0e.jpg";